import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import { calculateMinutesFromWords } from '@src/services/package';
import { WORD_MIN } from '@src/constants/package';
import {
  StyledHeaderMobile,
  StyledSubscriptionSuggestion,
} from './index.style';
import NeedForm from './NeedForm';
import BestPackageSuggestion from './Package';

const SubscriptionSuggestion = ({ packagesData, allVouchers }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [valueSlider, setValueSlider] = useState({
    numberOfContentsProduced: 1,
    yourContentDuration: calculateMinutesFromWords(WORD_MIN),
    yourScriptWordCount: WORD_MIN,
  });

  const [options, setOptions] = useState({
    useForeignVoice: true,
    useVoiceClone: true,
  });

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <StyledSubscriptionSuggestion>
      {history.location.pathname === ROUTES.MOBILE_SUBSCRIPTION_SUGGESTION && (
        <StyledHeaderMobile>
          <ArrowBackRoundedIcon
            onClick={handleGoBack}
            sx={{ fontSize: 24, color: COLOR.navyBlue }}
          />
          <Typography variant="body-24-bold" color={COLOR.darkGray}>
            {t('findYourPlan')}
          </Typography>
          <div />
        </StyledHeaderMobile>
      )}
      <NeedForm
        valueSlider={valueSlider}
        setValueSlider={setValueSlider}
        options={options}
        setOptions={setOptions}
      />
      <BestPackageSuggestion
        useVoiceClone={options.useVoiceClone}
        packagesData={packagesData}
        allVouchers={allVouchers}
        valueSlider={valueSlider}
        options={options}
      />
    </StyledSubscriptionSuggestion>
  );
};
export default SubscriptionSuggestion;
